/** @type {import("vue").Directive} */
const directive = {
  mounted: (element, binding) => {
    element.clickOutsideEvent = (event) => {
      if (!(element === event.target || element.contains(event.target))) {
        const shouldProceed = binding.value(event);
        // if the handler explicitly returns false, we ignore the click
        if (shouldProceed === false) {
          event.stopImmediatePropagation();
          event.stopPropagation();
          event.preventDefault();
        }
      }
    };
    document.body.addEventListener("click", element.clickOutsideEvent);
  },
  beforeUnmount: (element) => {
    document.body.removeEventListener("click", element.clickOutsideEvent);
  },
};

export default directive;
